import React, { useEffect, useState } from 'react';
import AdminProductFeedbackCard from '../../components/AdminProductFeedbackCard/AdminProductFeedbackCard';
import { RiStarSFill } from 'react-icons/ri';
import { USER_URL } from '../../constant/api';

function AdminProductFeedback() {
    const [productFeedbacks, setProductFeedbacks] = useState([]);
    const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
    const [selectedRating, setSelectedRating] = useState(null);
    const [productName, setProductName] = useState('');
    const [sellerName, setSellerName] = useState('');

    const fetchData = async () => {
        try {
            const response = await USER_URL.get(`/products/admin/product-feedback/`);
            const feedbackData = response.data.Data || [];
            setProductFeedbacks(feedbackData);
            setFilteredFeedbacks(feedbackData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        let filtered = productFeedbacks;

        if (selectedRating !== null) {
            filtered = filtered.filter(feedback => feedback.rating === selectedRating);
        }
        if (productName) {
            filtered = filtered.filter(feedback => feedback.product_name.toLowerCase().includes(productName.toLowerCase()));
        }
        if (sellerName) {
            filtered = filtered.filter(feedback => feedback.seller_name.toLowerCase().includes(sellerName.toLowerCase()));
        }

        setFilteredFeedbacks(filtered);
    }, [selectedRating, productName, sellerName, productFeedbacks]);

    return (
        <div className="p-4">
            <h1 className="text-2xl font-medium text-green-600 ">Product Feedback</h1>

            {/* Filters Section */}
            <div className="flex flex-wrap gap-3 mb-4 items-center">
                <button
                    className={`px-3 py-2 rounded w-full sm:w-auto ${selectedRating === null ? 'bg-green-500 text-white' : 'border border-gray-300'}`}
                    onClick={() => setSelectedRating(null)}
                >
                    All
                </button>

                <input
                    type="text"
                    placeholder="Product Name"
                    className="p-2 border rounded flex-1 min-w-[150px] w-full sm:w-auto"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                />

                <input
                    type="text"
                    placeholder="Seller Name"
                    className="p-2 border rounded flex-1 min-w-[150px] w-full sm:w-auto"
                    value={sellerName}
                    onChange={(e) => setSellerName(e.target.value)}
                />

                {/* Ratings */}
                <div className="flex gap-2 overflow-x-auto w-full sm:w-auto">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <button
                            key={star}
                            className={`px-3 py-2 flex items-center justify-center rounded w-full sm:w-auto ${selectedRating === star ? 'bg-green-500 text-white' : 'border border-gray-300'}`}
                            onClick={() => setSelectedRating(star === selectedRating ? null : star)}
                        >
                            <RiStarSFill className="mr-1 text-yellow-500 text-lg" /> {star}
                        </button>
                    ))}
                </div>
            </div>

            {/* Feedback Cards Grid */}
            <div className="grid grid-cols-1 gap-4">
                {filteredFeedbacks.map((feedback) => (
                    <AdminProductFeedbackCard key={feedback.id} feedback={feedback} />
                ))}
            </div>
        </div>
    );
}

export default AdminProductFeedback;
